import React from 'react'

const ReviewTab = () => {
    return (
        <li>

            <div className="review-summary">
                <h4 className="review-summary-title"> Student feedback </h4>
                <div className="review-summary-container">
                    <div className="review-summary-avg">
                        <div className="avg-number">
                            4.8
                            </div>
                        <div className="review-star">
                            <div className="star-rating"><span className="star"></span><span
                                className="star"></span><span className="star"></span><span
                                    className="star"></span><span className="star half"></span></div>
                        </div>
                        <span>Course Rating</span>
                    </div>


                    <div className="review-summary-rating">
                        <div className="review-summary-rating-wrap">
                            <div className="review-bars">
                                <div className="full_bar">
                                    <div className="bar_filler" style={{ width: "95%" }}></div>
                                </div>
                            </div>
                            <div className="review-stars">
                                <div className="star-rating"><span className="star"></span><span
                                    className="star"></span><span className="star"></span><span
                                        className="star"></span><span className="star"></span></div>
                            </div>
                            <div className="review-avgs">
                                95 %
                                </div>
                        </div>
                        <div className="review-summary-rating-wrap">
                            <div className="review-bars">
                                <div className="full_bar">
                                    <div className="bar_filler" style={{ width: "80%" }}></div>
                                </div>
                            </div>
                            <div className="review-stars">
                                <div className="star-rating"><span className="star"></span><span
                                    className="star"></span><span className="star"></span><span
                                        className="star"></span><span className="star empty"></span>
                                </div>
                            </div>
                            <div className="review-avgs">
                                80 %
                                </div>
                        </div>
                        <div className="review-summary-rating-wrap">
                            <div className="review-bars">
                                <div className="full_bar">
                                    <div className="bar_filler" style={{ width: "60%" }}></div>
                                </div>
                            </div>
                            <div className="review-stars">
                                <div className="star-rating"><span className="star"></span><span
                                    className="star"></span><span className="star"></span><span
                                        className="star empty"></span><span className="star empty"></span>
                                </div>
                            </div>
                            <div className="review-avgs">
                                60 %
                                </div>
                        </div>
                        <div className="review-summary-rating-wrap">
                            <div className="review-bars">
                                <div className="full_bar">
                                    <div className="bar_filler" style={{ width: "45%" }}></div>
                                </div>
                            </div>
                            <div className="review-stars">
                                <div className="star-rating"><span className="star"></span><span
                                    className="star"></span><span className="star empty"></span><span
                                        className="star empty"></span><span className="star empty"></span>
                                </div>
                            </div>
                            <div className="review-avgs">
                                45 %
                                </div>
                        </div>
                        <div className="review-summary-rating-wrap">
                            <div className="review-bars">
                                <div className="full_bar">
                                    <div className="bar_filler" style={{ width: "25%" }}></div>
                                </div>
                            </div>
                            <div className="review-stars">
                                <div className="star-rating"><span className="star"></span><span
                                    className="star empty"></span><span className="star empty"></span><span
                                        className="star empty"></span><span className="star empty"></span>
                                </div>
                            </div>
                            <div className="review-avgs">
                                25 %
                                </div>
                        </div>


                    </div>

                </div>
            </div>

            <div className="comments">
                <h4>Reviews <span className="comments-amount"> (4610) </span> </h4>

                <ul>
                    <li>
                        <div className="comments-avatar"><img src="../assets/images/avatars/avatar-2.jpg" alt="" />
                        </div>
                        <div className="comment-content">
                            <div className="comment-by">Stella Johnson<span>Student</span>
                                <div className="comment-stars">
                                    <div className="star-rating"><span className="star"></span><span
                                        className="star"></span><span className="star"></span><span
                                            className="star"></span><span className="star"></span></div>
                                </div>
                            </div>
                            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                            diam
                            nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
                            erat
                            volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci
                            tation
                            ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                            consequat.
                                </p>
                            <div className="comment-footer">
                                <span> Was this review helpful? </span>
                                <button> Yes </button>
                                <button> No </button>
                                <a href="#"> Report</a>
                            </div>
                        </div>

                    </li>

                    <li>
                        <div className="comments-avatar"><img src="../assets/images/avatars/avatar-3.jpg" alt="" />
                        </div>
                        <div className="comment-content">
                            <div className="comment-by"> Adrian Mohani <span>Instructor </span>
                                <div className="comment-stars">
                                    <div className="star-rating"><span className="star"></span><span
                                        className="star"></span><span className="star"></span><span
                                            className="star"></span><span className="star half"></span>
                                    </div>
                                </div>
                            </div>
                            <p> Ut wisi enim ad minim veniam, quis nostrud exerci tation
                            ullamcorper
                            suscipit lobortis nisl ut aliquip ex ea commodo consequat. Nam
                            liber
                            tempor cum soluta nobis eleifend
                                </p>
                            <div className="comment-footer">
                                <span> Was this review helpful? </span>
                                <button> Yes </button>
                                <button> No </button>
                                <a href="#"> Report</a>
                            </div>
                        </div>

                    </li>

                    <li>
                        <div className="comments-avatar"><img src="../assets/images/avatars/avatar-3.jpg" alt="" />
                        </div>
                        <div className="comment-content">
                            <div className="comment-by"> Adrian Mohani <span>Student</span>
                                <div className="comment-stars">
                                    <div className="star-rating"><span className="star"></span><span
                                        className="star"></span><span className="star"></span><span
                                            className="star"></span><span className="star"></span></div>
                                </div>
                            </div>
                            <p> Nam liber tempor cum soluta nobis eleifend option congue nihil
                            imperdiet doming id quod mazim placerat facer possim assum.
                            Lorem
                            ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                            nonummy
                            nibh euismod tincidunt ut laoreet dolore magna aliquam erat
                            volutpat.
                                </p>
                            <div className="comment-footer">
                                <span> Was this review helpful? </span>
                                <button> Yes </button>
                                <button> No </button>
                                <a href="#"> Report</a>
                            </div>
                        </div>

                    </li>

                    <li>
                        <div className="comments-avatar"><img src="../assets/images/avatars/avatar-2.jpg" alt="" />
                        </div>
                        <div className="comment-content">
                            <div className="comment-by">Stella Johnson<span>Student</span>
                                <div className="comment-stars">
                                    <div className="star-rating"><span className="star"></span><span
                                        className="star"></span><span className="star"></span><span
                                            className="star"></span><span className="star"></span></div>
                                </div>
                            </div>
                            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                            diam
                            nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
                            erat
                            volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci
                            tation
                            ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                            consequat.
                                </p>
                            <div className="comment-footer">
                                <span> Was this review helpful? </span>
                                <button> Yes </button>
                                <button> No </button>
                                <a href="#"> Report</a>
                            </div>
                        </div>

                    </li>

                </ul>

            </div>

            <div className="comments">
                <h3>Submit Review </h3>
                <ul>
                    <li>
                        <div className="comments-avatar"><img src="../assets/images/avatars/avatar-2.jpg" alt="" />
                        </div>
                        <div className="comment-content">
                            <form className="uk-grid-small" uk-grid="">
                                <div className="uk-width-1-2@s">
                                    <label className="uk-form-label">Name</label>
                                    <input className="uk-input" type="text" placeholder="Name" />
                                </div>
                                <div className="uk-width-1-2@s">
                                    <label className="uk-form-label">Email</label>
                                    <input className="uk-input" type="text" placeholder="Email" />
                                </div>
                                <div className="uk-width-1-1@s">
                                    <label className="uk-form-label">Comment</label>
                                    <textarea className="uk-textarea"
                                        placeholder="Enter Your Comments her..."
                                        style={{ height: "160px" }}></textarea>
                                </div>
                                <div className="uk-grid-margin">
                                    <input type="submit" value="submit" className="btn btn-default" />
                                </div>
                            </form>

                        </div>
                    </li>
                </ul>
            </div>

        </li>

    )
}

export default ReviewTab
